export const HIDE_CONFIRM = 'HIDE_CONFIRM'
export const RESET_CONFIRM = 'RESET_CONFIRM'
export const SET_CONFIRM_PROPS = 'SET_CONFIRM_PROPS'
export const SET_ERRORS_UUID = 'SET_ERRORS_UUID'
